/**
 * Returns true when viewport width is below the given breakpoint (px).
 * Uses `matchMedia` so the callback only fires when crossing the threshold,
 * instead of on every resize event — reducing main-thread work.
 */
import { useEffect, useState } from "react";

export function useViewportBreakpoint(breakpointPx: number): boolean {
    const [isBelow, setIsBelow] = useState(() =>
        typeof window !== "undefined" ? window.innerWidth < breakpointPx : false
    );

    useEffect(() => {
        const mql = window.matchMedia(`(max-width: ${breakpointPx - 1}px)`);
        setIsBelow(mql.matches);
        const handler = (e: MediaQueryListEvent) => setIsBelow(e.matches);
        mql.addEventListener("change", handler);
        return () => mql.removeEventListener("change", handler);
    }, [breakpointPx]);

    return isBelow;
}
